import styled from 'styled-components';

export const Title = styled.div`
  padding-top: 12px;
  padding-bottom: 12px;

  font-weight: 600;
  font-size: 14px;
`;
